// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wYN-","col":"styles_col__2VLQ9"};